import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CpComponent} from './cp.component';
import {routes} from './cp.routes';
import {RouterModule} from '@angular/router';
import {HeaderComponent} from './header/header.component';
import {SideMenuComponent} from './side-menu/side-menu.component';
import {CurrentUserComponent} from './current-user/current-user.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ReferralComponent} from './referral/referral.component';
import {ReferralService} from './referral/referral.service';
import {EditorsModule} from '../editors/editors.module';
import {AppsPopupComponent} from './header/apps-popup.component';
import {CoreModule} from '../core/core.module';
import {LocalNotificationsService} from '../core/services/local-notifications.service';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MainNavComponent} from './navigation/main-nav.component';
import {MatListModule} from '@angular/material/list';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatBadgeModule} from '@angular/material/badge';
import {MatMenuModule} from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MessageModule} from 'primeng/message';
import {MessagesModule} from 'primeng/messages';
import {GlobalNotificationsComponent} from './global-notification/global-notifications.component';
import {NotificationsComponent} from './notification/notifications.component';
import {ForbiddenComponent} from './forbidden/forbidden.component';
import {MatCardModule} from '@angular/material/card';
import {ToastModule} from 'primeng/toast';
import {ConfirmBecomeBetaDialogComponent} from './header/confirm-become-beta/confirm-become-beta-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {FlexModule} from '@angular/flex-layout';
import {DialogsModule} from '../dialogs/dialogs.module';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        CoreModule,
        EditorsModule,
        RouterModule.forChild(routes),
        MatSidenavModule,
        MatListModule,
        MatIconModule,
        MatButtonModule,
        MatToolbarModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatBadgeModule,
        MatMenuModule,
        MatSlideToggleModule,
        MessageModule,
        MessagesModule,
        MatCardModule,
        ToastModule,
        MatDialogModule,
        FlexModule,
        DialogsModule,
        CpComponent,
        MainNavComponent,
        HeaderComponent,
        SideMenuComponent,
        CurrentUserComponent,
        AppsPopupComponent,
        ReferralComponent,
        NotificationsComponent,
        GlobalNotificationsComponent,
        ForbiddenComponent,
        ConfirmBecomeBetaDialogComponent,
    ],
    providers: [
        ReferralService,
        LocalNotificationsService,
    ]
})
export class CpModule {
}
